module.exports = __webpack_public_path__ + "img/unamused_face.cbfe2e0d.gif";